import { GridFilterModel } from "@mui/x-data-grid-pro";
import { format } from "date-fns";

const DATE_OPERATORS: Record<string, string> = {
  is: "==",
  onOrAfter: ">=",
  onOrBefore: "<=",
  after: ">",
  before: "<",
};

const NUMERIC_OPERATORS: Record<string, string> = {
  "=": "==",
  ">": ">",
  ">=": ">=",
  "<": "<",
  "<=": "<=",
};

export const buildRsqlFilters = (
  filterModel: GridFilterModel,
  dateFields: string[] = [],
  numericFields: string[] = []
): string | undefined => {
  const parts = filterModel.items
    .filter((item) => item.value != null && item.value !== "")
    .map((item) => {
      const { field, operator, value } = item;

      if (dateFields.includes(field) && value instanceof Date) {
        const rsqlOp = DATE_OPERATORS[operator];
        return rsqlOp ? `${field}${rsqlOp}${format(value, "yyyy-MM-dd")}` : null;
      }

      if (numericFields.includes(field)) {
        const rsqlOp = NUMERIC_OPERATORS[operator];
        return rsqlOp ? `${field}${rsqlOp}${value}` : null;
      }

      if (operator === "contains") {
        return `${field}=like=*${value}*`;
      }

      return null;
    })
    .filter(Boolean);

  return parts.length > 0 ? parts.join(";") : undefined;
};
